module.exports = __webpack_public_path__ + "static/logo-ecf-new.cb66cbe6.png";